import React, { useEffect, useState } from 'react';
import { Box, Container, IconButton, Typography } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { MarkdownRendererWithAnchors } from '../components/content/MarkdownRenderer';

export const TermsPage: React.FC = () => {
  const navigate = useNavigate();
  const [termsMarkdown, setTermsMarkdown] = useState<string>('');
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/auth?signup=true');
    }
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/MUU.app.md', { cache: 'no-cache' });
        const text = await res.text();
        if (!cancelled) setTermsMarkdown(text);
      } catch {
        if (!cancelled) setTermsMarkdown('');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#ffffff', color: '#1d1d1f' }}>
      <Box
        component="header"
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          bgcolor: '#ffffff',
          borderBottom: '1px solid #d2d2d7',
        }}
      >
        <Container maxWidth={false} sx={{ maxWidth: 1024, px: { xs: 2, md: 3 } }}>
          <Box sx={{ height: 44, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <Box component="img" src="/logo.svg" alt="MUU" sx={{ height: 18 }} />
              <Typography sx={{ fontSize: 14, fontWeight: 600, letterSpacing: 0.2 }}>Legal</Typography>
            </Box>
            <Typography sx={{ fontSize: 12, color: '#6e6e73' }}>MUU</Typography>
          </Box>
        </Container>
      </Box>

      <Container maxWidth={false} sx={{ maxWidth: 1024, px: { xs: 2, md: 3 }, py: { xs: 4, md: 7 } }}>
        <Box sx={{ mb: { xs: 4, md: 6 } }}>
          <Typography
            sx={{
              fontSize: 12,
              letterSpacing: 1.2,
              textTransform: 'uppercase',
              color: '#6e6e73',
              mb: 1.25,
              textAlign: 'center',
            }}
          >
            Informações legais e avisos
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr auto 1fr',
              alignItems: 'center',
            }}
          >
            <Typography
              component="button"
              type="button"
              onClick={handleBack}
              sx={{
                justifySelf: 'start',
                p: 0,
                border: 0,
                background: 'transparent',
                WebkitAppearance: 'none',
                appearance: 'none',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 600,
                color: '#1d1d1f',
                WebkitTextFillColor: '#1d1d1f',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Voltar
            </Typography>
            <Typography
              sx={{
                justifySelf: 'center',
                textAlign: 'center',
                fontSize: { xs: 28, md: 40 },
                fontWeight: 700,
                letterSpacing: -0.6,
                lineHeight: 1.12,
              }}
            >
              Termos de uso
            </Typography>
            <Box />
          </Box>
        </Box>

        <Box sx={{ maxWidth: 820 }}>
          <Box
            sx={{
              textAlign: 'left',
              '& .MuiTypography-root': {
                color: '#1d1d1f',
              },
              '& a': {
                color: '#0066cc',
              },
            }}
          >
            {termsMarkdown ? (
              <MarkdownRendererWithAnchors text={termsMarkdown} headingIdPrefix="terms-" />
            ) : (
              <Typography variant="body1" sx={{ color: '#6e6e73' }}>
                Carregando…
              </Typography>
            )}
          </Box>
        </Box>
      </Container>

      <Box component="footer" sx={{ borderTop: '1px solid #d2d2d7', py: 4 }}>
        <Container maxWidth={false} sx={{ maxWidth: 1024, px: { xs: 2, md: 3 } }}>
          <Typography sx={{ fontSize: 12, color: '#6e6e73' }}>
            Copyright © {new Date().getFullYear()} MUU. Todos os direitos reservados.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};
